import React, { useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { selectCurrentNumber } from '../../redux/messages/messages.selectors';
import { selectUser } from '../../redux/user/user.selectors';

import { newTextStart, setReadStart } from '../../redux/messages/messages.actions';

const MessageChat = (props) => {
  const [textBody, setTextBody] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (textBody.trim() !== '') {
      props.newTextStart(props.currentNumber, textBody, props.employee.user);
      setTextBody('');
    } else alert('Please enter a message');
  };

  const handleChange = (event) => {
    const { value } = event.target;
    setTextBody(value);
  };

  const setRead = () => {
    if (props.currentContact.unreadText) {
      props.setReadStart(props.currentContact.id)
    }
  };

  return (
    <div className="nk-chat-editor">
      <div className="nk-chat-editor-form">
        <div className="form-control-wrap">
          <textarea
            className="form-control form-control-simple no-resize"
            rows="1"
            id="default-textarea"
            placeholder="Type your message..."
            spellCheck="false"
            name="textBody"
            value={textBody}
            maxLength="255"
            onFocus={setRead}
            onChange={handleChange}></textarea>
        </div>
      </div>
      <ul className="nk-chat-editor-tools g-2">
        <li>
          <button className="btn btn-round btn-primary btn-icon"
            onClick={handleSubmit}><em className="icon ni ni-send-alt"></em></button>
        </li>
      </ul>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  currentNumber: selectCurrentNumber,
  employee: selectUser,
});

const mapDispatchToProps = (dispatch) => ({
  newTextStart: (number, message, employee) =>
    dispatch(newTextStart(number, message, employee)),
  setReadStart: (num) => dispatch(setReadStart(num)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MessageChat);
